import { useState } from 'react';

import { BlueButton, RedButton, ConfirmComment } from 'libs/ui';
import { Content, Item } from './gate-control.styled';

let current;

export const GateControl = (props) => {
  const { items, sendControlMsg } = props;
  const [confirm, setConfirm] = useState({});
  const withComment = window.dict['reasonofpass'] !== undefined;

  /**
   * action after confirm
   * @param {*} msg
   */
  const actionAfterConfirm = (msg) => {
    sendControlMsg(current.msg, null, { comment: msg });
  };

  /**
   * get elements from items
   * @returns
   */
  const getItems = () => {
    return items.map((el, idx) => {
      const { icon, color, title, withConfirm, msg, confirmTop, disabled, ...rest } = el;
      const Cmp = color === 'red' ? RedButton : BlueButton;

      /**
       * close confirm
       */
      const closeConfirm = () => {
        const out = { ...confirm };
        delete out[idx];
        setConfirm(out);
      };

      /**
       * click on button
       * @returns
       */
      const click = (event) => {
        if (disabled) {
          event.stopPropagation();
          event.preventDefault();
          return;
        }
        if (withConfirm && withComment) {
          current = el;
          const out = { ...confirm };
          out[idx] = true;
          setConfirm(out);
          return;
        }
        sendControlMsg(msg);
      };

      return (
        <Item key={idx} {...rest}>
          <Cmp onClick={click} disabled={disabled}>
            {icon && <img src={`/images/${icon}`} alt="" />}
            {title}
          </Cmp>
          {confirm[idx] && <ConfirmComment above={false} arrowPos={'95px'} topPos={confirmTop} close={closeConfirm} action={actionAfterConfirm} />}
        </Item>
      );
    });
  };

  const itemsEl = getItems();

  return (
    <>
      <Content>{itemsEl}</Content>
    </>
  );
};
